
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/black-background",
      function () {
        return require("private-next-pages/black-background/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/black-background"])
      });
    }
  